var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsTax({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 0H44.28C55.12 0 63.88 4.27984 64 15.1594V75.8771C64 76.557 63.84 77.237 63.52 77.837C63 78.797 62.12 79.5169 61.04 79.8369C60 80.1569 58.84 79.9969 57.88 79.4369L31.96 66.4774L6 79.4369C5.404 79.7529 4.72 79.9569 4.04 79.9569C1.8 79.9569 0 78.117 0 75.8771V15.1594C0 4.27984 8.8 0 19.6 0ZM16.88 30.4789H47C48.72 30.4789 50.12 29.0749 50.12 27.319C50.12 25.559 48.72 24.1591 47 24.1591H16.88C15.16 24.1591 13.76 25.559 13.76 27.319C13.76 29.0749 15.16 30.4789 16.88 30.4789Z",
    fill: "url(#paint0_linear_4264_2047)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4264_2047",
    x1: -17.9228,
    y1: 0,
    x2: -17.9228,
    y2: 124.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsTax);
export default __webpack_public_path__ + "static/media/stats-tax.36b1421447518c9668d8f02761fc4fcf.svg";
export { ForwardRef as ReactComponent };